import React, { lazy, Suspense } from 'react';
import { MapTo } from '@adobe/aem-react-editable-components';
import { SpinnerLoader } from '@yme/atoms/spinner-loader';
import { AEM_FUNCTIONS } from '@yme/common/aem-functions';
import { withTranslation } from '@yme/services/i18n';
import { isDealerLocatorEmpty } from './helpers';
import { DealerLocatorStyled } from './styled';
const DealerLocator = lazy(() => import('./DealerLocator'));
const dealerLocatorEditConfig = {
    emptyLabel: 'Dealer Locator',
    isEmpty: isDealerLocatorEmpty,
};
function ComponentHolder(arg) {
    return (React.createElement(DealerLocatorStyled, null,
        React.createElement(Suspense, { fallback: React.createElement(SpinnerLoader, { isLoading: true, hasBackground: false }) },
            React.createElement(DealerLocator, { ...arg }))));
}
export default MapTo(AEM_FUNCTIONS.dealerLocator)(withTranslation(ComponentHolder), dealerLocatorEditConfig);
